/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createAdditionalQuestionDataSubtypeSchema = z.union([z.literal('multiple'), z.literal(null)])

export type CreateAdditionalQuestionDataSubtypeSchema = z.infer<typeof createAdditionalQuestionDataSubtypeSchema>
